import { render } from "./JobsListItem.vue?vue&type=template&id=70ea844a"
import script from "./JobsListItem.vue?vue&type=script&lang=js"
export * from "./JobsListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__